export default {
  FETCH_PRICE_POINTS_DICTIONARY_REQUEST: 'FETCH_PRICE_POINTS_DICTIONARY_REQUEST',
  FETCH_PRICE_POINTS_DICTIONARY_SUCCESS: 'FETCH_PRICE_POINTS_DICTIONARY_SUCCESS',
  FETCH_PRICE_POINTS_DICTIONARY_FAILURE: 'FETCH_PRICE_POINTS_DICTIONARY_FAILURE',

  FETCH_PACK_STATUSES_DICTIONARY_REQUEST: 'FETCH_PACK_STATUSES_DICTIONARY_REQUEST',
  FETCH_PACK_STATUSES_DICTIONARY_SUCCESS: 'FETCH_PACK_STATUSES_DICTIONARY_SUCCESS',
  FETCH_PACK_STATUSES_DICTIONARY_FAILURE: 'FETCH_PACK_STATUSES_DICTIONARY_FAILURE',

  FETCH_ORDER_STATUSES_DICTIONARY_REQUEST: 'FETCH_ORDER_STATUSES_DICTIONARY_REQUEST',
  FETCH_ORDER_STATUSES_DICTIONARY_SUCCESS: 'FETCH_ORDER_STATUSES_DICTIONARY_SUCCESS',
  FETCH_ORDER_STATUSES_DICTIONARY_FAILURE: 'FETCH_ORDER_STATUSES_DICTIONARY_FAILURE',

  FETCH_USER_CLASS_DICTIONARY_REQUEST: 'FETCH_USER_CLASS_DICTIONARY_REQUEST',
  FETCH_USER_CLASS_DICTIONARY_SUCCESS: 'FETCH_USER_CLASS_DICTIONARY_SUCCESS',
  FETCH_USER_CLASS_DICTIONARY_FAILURE: 'FETCH_USER_CLASS_DICTIONARY_FAILURE',

  FETCH_REPORT_CATEGORIES_DICTIONARY_REQUEST: 'FETCH_REPORT_CATEGORIES_DICTIONARY_REQUEST',
  FETCH_REPORT_CATEGORIES_DICTIONARY_SUCCESS: 'FETCH_REPORT_CATEGORIES_DICTIONARY_SUCCESS',
  FETCH_REPORT_CATEGORIES_DICTIONARY_FAILURE: 'FETCH_REPORT_CATEGORIES_DICTIONARY_FAILURE',

  FETCH_TIERS_DICTIONARY_REQUEST: 'FETCH_TIERS_DICTIONARY_REQUEST',
  FETCH_TIERS_DICTIONARY_SUCCESS: 'FETCH_TIERS_DICTIONARY_SUCCESS',
  FETCH_TIERS_DICTIONARY_FAILURE: 'FETCH_TIERS_DICTIONARY_FAILURE',

  FETCH_INQUIRY_REASONS_DICTIONARY_REQUEST: 'FETCH_INQUIRY_REASONS_DICTIONARY_REQUEST',
  FETCH_INQUIRY_REASONS_DICTIONARY_SUCCESS: 'FETCH_INQUIRY_REASONS_DICTIONARY_SUCCESS',
  FETCH_INQUIRY_REASONS_DICTIONARY_FAILURE: 'FETCH_INQUIRY_REASONS_DICTIONARY_FAILURE',

  FETCH_INVOICE_DATES_DICTIONARY_REQUEST: 'FETCH_INVOICE_DATES_DICTIONARY_REQUEST',
  FETCH_INVOICE_DATES_DICTIONARY_SUCCESS: 'FETCH_INVOICE_DATES_DICTIONARY_SUCCESS',
  FETCH_INVOICE_DATES_DICTIONARY_FAILURE: 'FETCH_INVOICE_DATES_DICTIONARY_FAILURE',

  FETCH_USER_TEMPLATES_DICTIONARY_REQUEST: 'FETCH_USER_TEMPLATES_DICTIONARY_REQUEST',
  FETCH_USER_TEMPLATES_DICTIONARY_SUCCESS: 'FETCH_USER_TEMPLATES_DICTIONARY_SUCCESS',
  FETCH_USER_TEMPLATES_DICTIONARY_FAILURE: 'FETCH_USER_TEMPLATES_DICTIONARY_FAILURE',

  FETCH_OUTLET_TYPES_DICTIONARY_REQUEST: 'FETCH_OUTLET_TYPES_DICTIONARY_REQUEST',
  FETCH_OUTLET_TYPES_DICTIONARY_SUCCESS: 'FETCH_OUTLET_TYPES_DICTIONARY_SUCCESS',
  FETCH_OUTLET_TYPES_DICTIONARY_FAILURE: 'FETCH_OUTLET_TYPES_DICTIONARY_FAILURE',

  FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_REQUEST: 'FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_REQUEST',
  FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_SUCCESS: 'FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_SUCCESS',
  FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_FAILURE: 'FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_FAILURE',

  FETCH_ACTIVITY_EVENTS_DICTIONARY_REQUEST: 'FETCH_ACTIVITY_EVENTS_DICTIONARY_REQUEST',
  FETCH_ACTIVITY_EVENTS_DICTIONARY_SUCCESS: 'FETCH_ACTIVITY_EVENTS_DICTIONARY_SUCCESS',
  FETCH_ACTIVITY_EVENTS_DICTIONARY_FAILURE: 'FETCH_ACTIVITY_EVENTS_DICTIONARY_FAILURE',

  FETCH_LOTTERY_TERMS_DICTIONARY_REQUEST: 'FETCH_LOTTERY_TERMS_DICTIONARY_REQUEST',
  FETCH_LOTTERY_TERMS_DICTIONARY_SUCCESS: 'FETCH_LOTTERY_TERMS_DICTIONARY_SUCCESS',
  FETCH_LOTTERY_TERMS_DICTIONARY_FAILURE: 'FETCH_LOTTERY_TERMS_DICTIONARY_FAILURE',

  FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_REQUEST: 'FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_REQUEST',
  FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_SUCCESS: 'FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_SUCCESS',
  FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_FAILURE: 'FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/dictionaries.action-types.js